import httpClient from "./httpClient"; // Adjust path if necessary

const TeamMemberService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/member", {
      params: { page, pageSize }
    });
  },

  async create(entity) {
    return await httpClient.post("/member", entity);
  }
};

export default TeamMemberService;
